module.exports = __webpack_public_path__ + "static/000661-b00bc825849b96e765a7af76da57f6d7.jpg";